class Auth {
    constructor(user = null) {
        this._user = user;
        if(user){
            for (const key in user) {
                if(key !== 'password'){
                    this[key] = user[key];
                }
            }
        }
        this._saveUser(this._user);
    }

    getRole(){
        if(this.isAutoLoggedIn()){
            return 'auto-login';
        }
        if(!this._user){
            return '';
        }
        return this.role;
    }

    hasRole(role){
        if(!this._user){
            return false;
        }
        return this.role === role;
    }

    isAutoLoggedIn(){
        return !!this._equipment && !this._user;
    }

    isManager(){
        return this.hasRole('manager');
    }

    isUser(){
        return this.hasRole('user');
    }

    isGroupAdmin(){
        return this.hasRole('group-admin');
    }

    isAdmin(){
        return this.hasRole('admin');
    }

    isSuperAdmin(){
        return this.hasRole('super-admin');
    }

    isSharpAdmin(){
        return this.hasRole('admin') || this.hasRole('super-admin');
    }

    isAuth(){
        return !!this._user;
    }

    getUser() {
        return this._user
    }

    updateUser(user){
        if(user){
            for (const key in user) {
                if(key !== 'password'){
                    this[key] = user[key];
                    this._user[key] = user[key];
                }
            }
            this._saveUser(this._user);
        }
    }


    check() {
        return  this._equipment || (this._user && this.authtoken);
    }

    setEquipment(equipment){
        this._equipment = equipment;
    }

    _saveUser(user){
        if(user){
            let data = {
                authtoken: user.authtoken,
                role: user.role,
            }
            localStorage.setItem('_auth_user', JSON.stringify(data));
        }else{
            localStorage.removeItem('_auth_user');
        }
    }

}

export default Auth
